var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChaticonatasmb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58213 10.0869C5.2402 6.89513 8.06747 4.50742 11.4309 4.50742C14.7944 4.50742 17.6461 6.91949 18.2798 10.0869H22.8375C22.1307 4.40996 17.2805 0 11.4066 0C5.53268 0 0.706818 4.40996 0 10.0869H4.55776H4.58213Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4311 7.3335C13.7466 7.3335 15.5989 9.20956 15.5989 11.4998C15.5989 13.7901 13.7222 15.6661 11.4311 15.6661C9.14006 15.6661 7.26334 13.7901 7.26334 11.4998C7.26334 9.20956 9.14006 7.3335 11.4311 7.3335Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.9131C0.706818 18.59 5.55705 22.9999 11.4309 22.9999C17.3048 22.9999 22.1551 18.59 22.8619 12.9131H18.3041C17.6461 16.1048 14.8188 18.4925 11.4553 18.4925C8.09184 18.4925 9.43236 18.2733 8.53056 17.8591L4.58213 18.9311L5.55705 15.2764C5.09396 14.5699 4.77711 13.7658 4.6065 12.9131H0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaticonatasmb);
export default __webpack_public_path__ + "static/media/chaticonatasmb.e778b6db15b0719403ad29f2a515e656.svg";
export { ForwardRef as ReactComponent };